export default "__VITE_ASSET__DLbbxdHa__"